// Shared API helpers for CardSnap Value.
// Uses REACT_APP_BACKEND_URL from .env. Adds X-Guest-Id header so every request
// is scoped to this browser's local guest id.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GUEST_KEY = "cardsnap.guest_id";

export function getGuestId() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id) {
    id = `g-${crypto.randomUUID()}`;
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

export const api = axios.create({
  baseURL: API,
  timeout: 60_000,
});

api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers["X-Guest-Id"] = getGuestId();
  return cfg;
});

// --- Collections ---
export const listCollections = () => api.get("/collections").then((r) => r.data);
export const createCollection = (body) => api.post("/collections", body).then((r) => r.data);
export const deleteCollection = (id) => api.delete(`/collections/${id}`).then((r) => r.data);

// --- Card entries ---
export const listEntries = (params = {}) =>
  api.get("/card_entries", { params }).then((r) => r.data);
export const createEntry = (body) => api.post("/card_entries", body).then((r) => r.data);
export const updateEntry = (id, body) => api.patch(`/card_entries/${id}`, body).then((r) => r.data);
export const deleteEntry = (id) => api.delete(`/card_entries/${id}`).then((r) => r.data);

// --- Portfolio ---
export const getPortfolio = () => api.get("/portfolio").then((r) => r.data);

// --- Sets browser removed — scanner now handles pricing directly via Claude Sonnet 4.6 ---

// --- Scanning (existing) ---
export const scanCard = (payload) => api.post("/scan", payload, { timeout: 90_000 }).then((r) => r.data);

export { API };
